import { ProductListItemModel } from 'autogen/swagger/all';
import HorizontalProductItemCarousel from 'components/shared/productItem/components/HorizontalProductItem/components/HorizontalProductItemCarousel';
import useContainerQuery from 'hooks/responsive/useContainerQuery';
import { sizes } from 'variables';
import styled from 'styled-components';
import ProductGridWithLevels from '../../shared/productList/components/ProductGridWithLevels';

const Container = styled.div`
    min-width: 0;
`;

const layoutTypeBreakpoints = { [sizes.xs]: 'GridCarousel', [sizes.sm]: 'GridWithLevels' };

export default function SmallProductRecommendation({ items }: { items: ProductListItemModel[] }) {
    const [ref, type] = useContainerQuery(layoutTypeBreakpoints, null);

    return (
        <Container ref={ref}>
            {type === 'GridCarousel' && <HorizontalProductItemCarousel items={items} />}
            {type === 'GridWithLevels' && (
                <ProductGridWithLevels itemConfigType="horizontalProductItem" items={items} />
            )}
        </Container>
    );
}
